module.exports = __webpack_public_path__ + "img/Frame 1103hrp9.d59a9831.png";